export default __webpack_public_path__ + "static/media/com_icon.9fd355ed.svg";